import React from "react";
import { BsPencilFill } from "react-icons/bs";
import { ITranslations } from "../data/strings";

import avatar01 from "../img/avatars/001-monster.png";
import avatar02 from "../img/avatars/002-monster-1.png";
import avatar03 from "../img/avatars/003-monster-2.png";
import avatar04 from "../img/avatars/004-monster-3.png";
import avatar05 from "../img/avatars/005-monster-4.png";
import avatar06 from "../img/avatars/006-monster-5.png";
import avatar07 from "../img/avatars/007-monster-6.png";
import avatar08 from "../img/avatars/008-monster-7.png";
import avatar09 from "../img/avatars/009-monster-8.png";
import avatar10 from "../img/avatars/010-nature.png";
import avatar11 from "../img/avatars/011-camping.png";
import avatar12 from "../img/avatars/012-island.png";
import avatar13 from "../img/avatars/013-rose.png";
import avatar14 from "../img/avatars/014-golden-gate-bridge.png";
import avatar15 from "../img/avatars/015-hamburger.png";
import avatar16 from "../img/avatars/016-barbecue.png";
import avatar17 from "../img/avatars/017-cupcake.png";
import avatar18 from "../img/avatars/018-lemon.png";
import avatar19 from "../img/avatars/019-lollipop.png";
import avatar20 from "../img/avatars/020-coffee.png";

import { ELCID } from "../models/IMediaToolkit";
import { Modal } from "./Modal";

export interface IAvatarProps {
    avatarId: number;
    uniqueKey: string;
    lcid: ELCID;
    translations: ITranslations;
    editable?: boolean;
    updateAvatar?: (idx: number) => void;
    size?: 8 | 12 | 14 | 16 | 24 | 32 | 48 | 64 | 96;
    additionalClasses?: string;
}

export const avatars: string[] = [
    avatar01,
    avatar02,
    avatar03,
    avatar04,
    avatar05,
    avatar06,
    avatar07,
    avatar08,
    avatar09,
    avatar10,
    avatar11,
    avatar12,
    avatar13,
    avatar14,
    avatar15,
    avatar16,
    avatar17,
    avatar18,
    avatar19,
    avatar20,
];

export const Avatar: React.FunctionComponent<IAvatarProps> = (props) => {
    const [avatarPickerOpen, setAvatarPickerOpen] = React.useState<boolean>(false);
    const sizeStr = (props.size || 64).toString();

    return (
        <div className={`relative h-${sizeStr} h-max`}>
            <div
                style={{ width: `${sizeStr}px`, height: `${sizeStr}px` }}
                className={`border border-aap-gray-200 rounded-full overflow-hidden p-2 ${
                    props.additionalClasses ? props.additionalClasses : ""
                }`}
                key={props.uniqueKey}
            >
                <img className="w-full h-auto" src={avatars[props.avatarId]} alt={`Family member avatar`} />
            </div>
            {props.editable ? (
                <>
                    <button
                        type="button"
                        className="w-6 h-6 rounded-full border border-aap-green-500 bg-white hover:bg-aap-green-500 hover:border-aap-green-500 absolute bottom-0 -right-2 text-aap-orange-500 hover:text-white"
                        onClick={() => setAvatarPickerOpen(true)}
                        id={`btn_editAvatar_${ELCID[props.lcid]}`}
                    >
                        <BsPencilFill
                            size={12}
                            className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2"
                        />
                    </button>
                    <Modal visible={avatarPickerOpen} onClose={() => setAvatarPickerOpen(false)} lcid={props.lcid}>
                        <>
                            <div className="p-5">
                                <h2 className="text-4xl">{props.translations.selectYourAvatar}</h2>
                                <p>{props.translations.selectAvatarBlurb}</p>
                            </div>
                            <div className="bg-aap-brown-300 text-center py-5">
                                {avatars.map((avatar, idx) => {
                                    return (
                                        <div
                                            className="inline-block relative m-3"
                                            key={`${props.uniqueKey}-avatarbuttonwrap-${idx}`}
                                        >
                                            <button
                                                type="button"
                                                className="rounded-full p-3 w-24 h-24 mx-auto bg-white border border-aap-gray-400 hover:border-aap-orange-500 hover:shadow-lg hover:shadow-aap-gray-300 transition-all block overflow-hidden"
                                                onClick={() => {
                                                    if (props.updateAvatar) {
                                                        props.updateAvatar(idx);
                                                    }
                                                    setAvatarPickerOpen(false);
                                                }}
                                                key={`${props.uniqueKey}-avatarbutton-${idx}`}
                                                id={`btn_selectAvatar_${ELCID[props.lcid]}`}
                                            >
                                                <img src={avatar} alt="Avatar Preview" className="w-full h-auto mx-auto" />
                                            </button>
                                        </div>
                                    );
                                })}
                            </div>
                        </>
                    </Modal>
                </>
            ) : null}
        </div>
    );
};
